import { useId } from "react";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import SupportIcon from "@mui/icons-material/Support";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import {
  ActionSheetMenu,
  ActionSheetMenuItem,
  ResponsiveActionSheetMenu,
} from "@shared/components/ActionSheetMenu";
import { useIntercomIntegration } from "@shared/services/intercom/useIntercomIntegration";
import { useUIStore } from "@store/ui.store";
import { useGetPreferences } from "@shared/generated/radar/queries/usersController/useGetPreferences";
import { useRadarOnboardingStore } from "@modules/radar/shared/store/radar-onboarding.store";
import { useEventSubscriptionsStore } from "@modules/radar/shared/store/event-subscriptions.store";
import { useFeatureFlag } from "@shared/services/posthog/use-feature-flag";

export const RadarPageMoreActions = () => {
  const menuId = useId();
  const intercom = useIntercomIntegration();
  const toggleSupportDialogMode = useUIStore(
    (state) => state.toggleSupportDialogMode,
  );
  const openPreferences = useRadarOnboardingStore((state) => state.open);
  const openEventSubscriptions = useEventSubscriptionsStore(
    (state) => state.open,
  );
  const isEventSubscriptionsEnabled = useFeatureFlag(
    "radar-event-subscriptions",
  );
  // Same request RadarOnboardingGate fires - React Query dedupes by query key,
  // so this doesn't cost an extra request, just lets the menu disable
  // "Preferences" until it knows whether there's anything to show yet.
  const preferencesQuery = useGetPreferences();

  const handleOpenSupportHome = () => {
    intercom.hide();
    toggleSupportDialogMode({ mode: "home" });
  };

  return (
    <ResponsiveActionSheetMenu
      renderTrigger={({ triggerRef, onClick, isSheet, open }) => (
        <IconButton
          ref={triggerRef}
          onClick={onClick}
          size="small"
          aria-label="More options"
          aria-haspopup="menu"
          aria-expanded={open}
          aria-controls={menuId}
          sx={
            isSheet
              ? { "&:focus": { backgroundColor: "transparent" } }
              : undefined
          }
        >
          <MoreHorizIcon />
        </IconButton>
      )}
    >
      {(closeMenu) => (
        <ActionSheetMenu id={menuId}>
          <ActionSheetMenuItem
            icon={<SettingsOutlinedIcon />}
            label="Preferences"
            disabled={!preferencesQuery.isSuccess}
            onClick={() => {
              closeMenu();
              openPreferences();
            }}
          />
          {isEventSubscriptionsEnabled === true && (
            <ActionSheetMenuItem
              icon={<WebhookOutlinedIcon />}
              label="Event subscriptions"
              onClick={() => {
                closeMenu();
                openEventSubscriptions();
              }}
            />
          )}
          <ActionSheetMenuItem
            icon={<SupportIcon />}
            label="Support"
            onClick={() => {
              closeMenu();
              handleOpenSupportHome();
            }}
          />
        </ActionSheetMenu>
      )}
    </ResponsiveActionSheetMenu>
  );
};
